// This file contains material which is the pre-existing property of Psycle
// Interactive Limited.
// Copyright (c) 2018 Psycle Interactive. All rights reserved.

const casestudyData = {
  id: 'armani-smartwatch',
  heroImg: 'hero.jpg',
  heroTheme: 'light',
  heroHeadingOne: 'Armani Smart Watch',
  heroHeadingTwo: 'Global Launch Events',
  details: [
    {
      title: 'AGENCY',
      items: ['Psycle'],
    },
    {
      title: 'PLATFORM',
      items: ['Dialogflow', 'Firebase', 'Facebook Messenger'],
    },
    {
      title: 'LAUNCH',
      items: ['June 2017 - November 2017'],
    },
  ],
  heading: 'Multi-language chatbot to support global appearances of Armani brand ambassador Shawn Mendes',
  challengeImg: 'challenge.png',
  challenge: false,
  solution: [
    'Experience provides users with details about events, competitions, free gifts and the opportunity to interact directly with the Canadian popstar.',
    'Integration with Facebook Messenger provides users with updates on events and contextual instructions for participation.',
  ],
  footerImg: 'solution.jpg',
  nextCaseStudy: 'john-lewis-storybook',
};

export default casestudyData;
